import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/forecast";

export default function CategoriesSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="瓜田地图"
          title="六大分类，按你的兴趣蹲守"
          description="不同领域的信号类型差别很大。选一个你常关注的圈子，我们只推送那个方向的预警。"
          actionLabel="浏览全部分类"
          actionTo="/topics"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {categories.map((cat, index) => (
            <Reveal key={cat.id} delay={index * 70}>
              <Link
                to={`/forecast?category=${cat.id}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-6"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-50 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={cat.icon} />
                  </span>
                  <span className="font-heading text-xs font-semibold text-foreground-400">{cat.count} 条前瞻</span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}